import * as i0 from "@angular/core";
var CopyService = /** @class */ (function () {
    function CopyService() {
    }
    CopyService.prototype.copyText = function (text) {
        this.createTextareaAndSelect(text);
        var copySuccessful = document.execCommand('copy');
        this.removeFake();
        return copySuccessful;
    };
    CopyService.prototype.createTextareaAndSelect = function (text) {
        this.textarea = document.createElement('textarea');
        this.textarea.style.fontSize = '12pt';
        this.textarea.classList.add('cdk-visually-hidden');
        var yPosition = window.pageYOffset || document.documentElement.scrollTop;
        this.textarea.style.top = yPosition + 'px';
        this.textarea.setAttribute('readonly', '');
        this.textarea.value = text;
        document.body.appendChild(this.textarea);
        this.textarea.select();
        this.textarea.setSelectionRange(0, this.textarea.value.length);
    };
    CopyService.prototype.removeFake = function () {
        if (this.textarea) {
            document.body.removeChild(this.textarea);
            this.textarea = null;
        }
    };
    CopyService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CopyService_Factory() { return new CopyService(); }, token: CopyService, providedIn: "root" });
    return CopyService;
}());
export { CopyService };
